import { Transforms } from 'vendor/slate'
import { ELEMENT_TYPES } from 'cg/components/documents/editor/slate/types'
import { v4 as uuidv4 } from 'uuid'

const insertMermaid = (editor, path) => {
  const mermaid = {
    type: ELEMENT_TYPES.mermaid,
    chart: 'graph TD;A-->B;A-->C;B-->D;C-->D;',
    children: [{ uuid: uuidv4(), text: '', parent: { type: ELEMENT_TYPES.mermaid } }]
  }

  Transforms.insertNodes(editor, mermaid, { at: path })
}

export { insertMermaid }
